module.exports = __webpack_public_path__ + "static/media/lego-head-403.584a78c1.svg";